import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDebounce } from "../../hooks/useDebounce";
import { useGetProductsSearchQuery } from "../../hooks/useProducts";
import { numberFormatter } from "../../helper/helpers";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../Features/Cart/cartActions";

export function SearchModal({ open, onOpenChange }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [pageData, setPageData] = useState({
    pageIndex: 0,
    pageSize: 10,
    // onlyPrescription: true,
  });

  const debouncedSearch = useDebounce(search, 500);

  const {
    data = {},
    isPending = false,
    isError: prdouctsIsError,
    error: productsError,
  } = useGetProductsSearchQuery({ ...pageData, search: debouncedSearch });
  let { data: products = [] } = data?.products ?? {};

  let totalItemCount = data?.products?.count ?? 0;
  let totalPages = Math.floor(totalItemCount / pageData.pageSize);

  const handleAddtoCart = (item) => {
    dispatch(addToCart({ ...item, quantity: 1 }));
  };

  const hasNextPage = () => {
    return pageData.pageIndex + 1 >= totalPages;
  };
  // const hasNextPage = () => {
  //   return pageData.pageIndex + 1 >= pageSize / pageData.pageSize;
  // };

  return (
    <React.Fragment>
      <Modal show={open} onHide={onOpenChange} size="lg" scrollable>
        <Modal.Header className="py-1" closeButton>
          <p className="m-0 text-main-600 fw-bold">Search for product.</p>
        </Modal.Header>
        <Modal.Body>
          <div className="position-relative">
            <input
              type="text"
              className="form-control form-control-sm px-24 text-xl rounded-pill pe-64 search-input"
              placeholder="Search for a product or brand"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button
              type="submit"
              className="w-26 h-26 bg-main-600 rounded-circle text-xs text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-4"
              disabled
            >
              {isPending && search ? (
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></div>
              ) : (
                <i className="ph ph-magnifying-glass" />
              )}
            </button>
          </div>
          <div className="mt-5">
            <p className="my-5 d-flex justify-content-between text-xs">
              <span>Search results for"{search}"</span>
              <span>{totalItemCount} products found</span>
            </p>
            {prdouctsIsError ? (
              <div className="container-fluid text-center">
                <p className="m-0 text-danger">
                  Error searching an item {productsError}
                </p>
              </div>
            ) : (
              <>
                <div className="row">
                  {products.map((item, index) => (
                    <div
                      className="col-md-4 mb-5 position-relative"
                      key={index}
                    >
                      {/* <div className="border border-gray-100 p-5 hover-border-main-600 rounded-5 hstack gap-10"> */}
                      <div className="border border-gray-100 p-5 hover-border-main-600 rounded-5 hstack gap-10">
                        <Link
                          to={`/products/product-details/${item?.id}`}
                          onClick={onOpenChange}
                        >
                          <img
                            src={
                              item?.hasMainImage
                                ? item?.imageUrl
                                : "/assets/images/thumbs/product-two-img2.png"
                            }
                            className="img-flui"
                            width={50}
                            alt=""
                          />
                        </Link>
                        <div className="hstack">
                          <div className="d-flex flex-column">
                            <Link
                              to={`/products/product-details/${item?.id}`}
                              className="text-xs text-main-600 fw-medium w-100 hover-text-gray-900 text-truncate"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title={item?.name}
                              style={{ maxWidth: "150px" }}
                              onClick={onOpenChange}
                            >
                              {item?.name}
                            </Link>
                            <span className="text-xs text-gray">
                              {item?.categoryName}
                            </span>
                            <p className="text-xs fw-bold">
                              <span className="text-dark">
                                {numberFormatter.format(
                                  Number(item?.price),
                                )}{" "}
                              </span>
                              <span className="text-gray-500 fw-normal">
                                /Qty
                              </span>{" "}
                            </p>
                            {item?.stockQuantity === 0 && (
                              <p className="text-danger-600 text-xs">
                                Out of Stock
                              </p>
                            )}
                          </div>
                          {item?.stockQuantity !== 0 && (
                            <button
                              className="btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white p-8 rounded-pill flex-align gap-8"
                              onClick={() => handleAddtoCart(item)}
                              disabled={item?.stockQuantity === 0}
                            >
                              <i className="ph ph-shopping-cart" />
                            </button>
                          )}

                          {/* <div className="d-flex justify-content-end">
                            {item?.isPrescription ? (
                              <button
                                className="product-card__cart btn bg-danger-600 text-white hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
                                disabled
                                onClick={() => handleAddtoCart(item)}
                              >
                                Prescription
                              </button>
                            ) : (
                              <button
                                className="product-card__cart btn btn-sm bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
                                onClick={() => handleAddtoCart(item)}
                                disabled={item?.stockQuantity === 0}
                              >
                                <i className="ph ph-shopping-cart" />
                              </button>
                            )}
                          </div> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <hr />
                {search && (
                  <div className="d-flex justify-content-start">
                    <div className="hstack gap-5">
                      <button
                        className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white transition-1"
                        disabled={pageData.pageIndex === 0}
                        onClick={() =>
                          setPageData((prevData) => ({
                            ...prevData,
                            pageIndex: prevData.pageIndex - 1,
                          }))
                        }
                      >
                        <i className="ph-bold ph-arrow-left" />
                      </button>
                      {!hasNextPage() && (
                        <button
                          className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white transition-1"
                          disabled={hasNextPage()}
                          onClick={() =>
                            setPageData((prevData) => ({
                              ...prevData,
                              pageIndex: prevData.pageIndex + 1,
                            }))
                          }
                        >
                          <i className="ph-bold ph-arrow-right" />
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
